import { cn } from '@/utils/tailwind-util';
// @ts-nocheck
import { Menu } from '@headlessui/react';
import React from 'react';

import Transition from '@/components/Transition';

interface Props {
  refElement: React.ReactNode;
  disabled?: boolean;
  dropSide?: 'top-left' | 'bottom-left' | 'top-right' | 'bottom-right';
}

const dropSideStyle = (dropSide: Props['dropSide']) => {
  switch (dropSide) {
    case 'top-left':
      return 'bottom-full left-0 mb-1.5 origin-top-left';
    case 'bottom-left':
      return 'top-full left-0 mt-1.5 origin-bottom-left';
    case 'top-right':
      return 'bottom-full mb-1.5 right-0 origin-top-right';
    case 'bottom-right':
    default:
      return 'top-full right-0 mt-1.5 origin-bottom-right';
  }
};

const Dropdown: React.FC<Props> = ({
  refElement,
  disabled = false,
  dropSide,
  children,
}) => (
  <Menu as="div" className={cn('relative inline-block text-left w-auto h-10')}>
    <Menu.Button
      as="div"
      disabled={disabled}
      className={cn('inline-flex h-10')}
    >
      {refElement}
    </Menu.Button>

    {!disabled ? (
      <Transition
        as={React.Fragment}
        enter={'transition ease-out duration-100'}
        enterFrom={'transform opacity-0 scale-95'}
        enterTo={'transform opacity-100 scale-100'}
        leave={'transition ease-in duration-75'}
        leaveFrom={'transform opacity-100 scale-100'}
        leaveTo={'transform opacity-0 scale-95'}
      >
        <Menu.Items
          className={cn(
            'w-auto min-w-40 bg-white rounded shadow-lg py-2 z-40',
            dropSide ? 'absolute' : 'fixed mt-1.5',
            dropSide && dropSideStyle(dropSide)
          )}
        >
          {React.Children.only(children)}
        </Menu.Items>
      </Transition>
    ) : (
      <></>
    )}
  </Menu>
);

export default Dropdown;
